import { IAction, StateStatus } from 'redux/utils/common';
import { IBlogOutput } from 'services/api/blogs';
import * as Types from './types';
import * as ProductService from 'services/api/product';
import { IDescriptionData } from '../configuration';

export interface IState {
  blogData: {
    status: StateStatus | null;
    data: IBlogOutput | null;
  };
  updateBlog: {
    status: StateStatus | null;
  };

  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  temporaryDescription: IDescriptionData[];
  temporaryTitle: IDescriptionData[];
}

const initialState: IState = {
  blogData: {
    status: null,
    data: null,
  },
  updateBlog: {
    status: null,
  },
  segments: {
    data: null,
    status: null,
  },
  temporaryDescription: [],
  temporaryTitle: [],
};

const BlogEditReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_ONE_BLOG:
      return {
        ...state,
        blogData: {
          ...state.blogData,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_BLOG:
      return {
        ...state,
        updateBlog: {
          status: action.status || null,
        },
      };
    case Types.UPDATE_DESCRIPTION_BLOG_TEMPORARY:
      return {
        ...state,
        temporaryDescription: action.data,
      };
    case Types.UPDATE_TITLE_BLOG_TEMPORARY:
      return {
        ...state,
        temporaryTitle: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};

export default BlogEditReducer;
